import { Flex, Spinner } from "@chakra-ui/react";
import { FormattedInput } from "components/FormInputs/FormattedInput";
import { Heading } from "components/Heading";
import { FileUploadSelectRFX } from "components/RFQ/FileUpload/FileUploadSelectRFX";
import { FileUploadSelectTemplate } from "components/RFQ/FileUpload/FileUploadSelectTemplate";
import { FieldForm } from "components/RFQ/Input/Input";
import { useState } from "react";
import tw, { styled } from "twin.macro";
import { AcceptedFileTypesForRFxWithImage } from "utils/rfxLargeFileUploadHelper";

const ProjectDetailContainer = styled.div(() => [tw`flex flex-col w-full`]);

const Documentation = ({
	rfxOrRfxTemplateId,
	titlePage,
	subTitlePage,
	documentCategories,
	isTemplate = false,
}) => {
	const isLoading = false;
	const [selectedCategory, setSelectedCategory] = useState(documentCategories?.[0]?.value || 1);

	return (
		<ProjectDetailContainer>
			<div
				id="subheader-page"
				className="py-8"
			>
				<div
					id="subheader-page-title"
					className="text-xl font-semibold text-primary-900"
				>
					<Heading
						fontSize={"36px"}
						color="#003CE9"
					>
						{" "}
						{titlePage}
					</Heading>
				</div>
				<div
					id="subheader-page-subtitle"
					className="mt-1 font-roboto text-sm text-tertiary-600"
				>
					{subTitlePage}
				</div>
			</div>
			<div
				id="project-detail-content"
				className="relative h-full min-h-[60vh]"
			>
				{!isLoading ? (
					<>
						<Flex>
							<FormattedInput
								label="Documentation Description (Optional)"
								name="documentation_description"
								characterLimit={1500}
								rfq
								className="w-full"
								placeholder={
									"E.g. Tender Documents - Information for Tenderers"
								}
								subTitle={
									"Summarise what documents are uploaded as part of this request."
								}
							/>
						</Flex>
						<Flex
							gap={8}
							marginBottom={20}
						>
							{isTemplate ? (
								<FileUploadSelectTemplate
									label={"Document upload"}
									multiple={true}
									name="documents"
									maxFileSize={500}
									types={AcceptedFileTypesForRFxWithImage}
									defaultFileName="Document"
									selectName="category_id"
									selectOptions={documentCategories}
									customMessage="Please select category before uploading the document"
									subtitle="Select a category and upload the relevant  document/s.  Once uploaded, you can re-order the documents.  "
									testId="upload-document"
									isTemplate={isTemplate}
									rfxTemplateId={rfxOrRfxTemplateId}
								>
									<FieldForm
										name="category_id"
										type="select"
										placeholder="Select category"
										className="my-3 w-60"
										options={documentCategories}
										onChange={(val) => setSelectedCategory(val)}
										onClick={(e) => e.stopPropagation()}
										size="sm"
										checkIcon
										value={selectedCategory}
									/>
								</FileUploadSelectTemplate>
							) : (
								<FileUploadSelectRFX
									label={"Document upload"}
									multiple={true}
									name="documents"
									maxFileSize={500}
									types={AcceptedFileTypesForRFxWithImage}
									defaultFileName="Document"
									selectName="category_id"
									selectOptions={documentCategories}
									customMessage="Please select category before uploading the document"
									subtitle="Select a category and upload the relevant  document/s.  Once uploaded, you can re-order the documents.  "
									testId="upload-document"
									rfxOrRfxTemplateId={rfxOrRfxTemplateId}
								>
									<FieldForm
										name="category_id"
										type="select"
										placeholder="Select category"
										className="my-3 w-60"
										options={documentCategories}
										onChange={(val) => setSelectedCategory(val)}
										onClick={(e) => e.stopPropagation()}
										size="sm"
										checkIcon
										value={selectedCategory}
									/>
								</FileUploadSelectRFX>
							)}
						</Flex>
					</>
				) : (
					<Spinner
						className="absolute left-1/2 top-[30vh] -translate-x-1/2"
						size="xl"
					/>
				)}
			</div>
		</ProjectDetailContainer>
	);
};

export default Documentation;
